module.exports = __webpack_public_path__ + "static/media/02_eq04.e32fd26f.jpg";